import { IconStorefront, Text } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import { Affiliates } from 'typings'
import { Tag, TagsList } from '../../../Tag'
import {
  Rule,
  RuleActions,
  RuleContent,
  RuleDescription,
  RuleIcon,
} from '../../RuleStack'
import { RuleDefaultActions } from '../../RuleStack/DefaultActions'
import { messages } from './messages'

type Props = {
  config: Affiliates | undefined
  onEdit: () => void
  onRemove: () => void
}

export function AffiliatesView(props: Props) {
  const { $t } = useIntl()

  const { config, onEdit, onRemove } = props

  if (!config) return null

  const { affiliates, operator } = config

  return (
    <Rule onClick={onEdit}>
      <RuleIcon>
        <IconStorefront />
      </RuleIcon>
      <RuleDescription>
        {$t(messages.view.title, {
          b: (content: React.ReactNode) => (
            <Text variant="body">{content}</Text>
          ),
          operator,
        })}
      </RuleDescription>

      <RuleContent>
        <TagsList>
          {affiliates.map(({ id, name }) => (
            <Tag key={id}>{name}</Tag>
          ))}
        </TagsList>
      </RuleContent>

      <RuleActions>
        <RuleDefaultActions onEdit={onEdit} onRemove={onRemove} />
      </RuleActions>
    </Rule>
  )
}
